import { Vue } from "vue-facing-decorator";

export abstract class AbstractComponent extends Vue {
    public async setup(): Promise<void> {
        // default implementation
    }

    public async beforeCreate(): Promise<void> {
        // default implementation
    }

    public async created(): Promise<void> {
        // default implementation
    }

    public async beforeMount(): Promise<void> {
        // default implementation
    }

    public async mounted(): Promise<void> {
        // default implementation
    }

    public async beforeUpdate(): Promise<void> {
        // default implementation
    }

    public async updated(): Promise<void> {
        // default implementation
    }

    public async beforeUnmount(): Promise<void> {
        // default implementation
    }

    public async unmounted(): Promise<void> {
        // default implementation
    }

    protected get props(): any {
        return this.$props;
    }
}
